import { c as _c } from "react/compiler-runtime";
import { PrimaryButton, SecondaryButton } from '@systemeio/ui';
import { ActionButton } from 'modules/stores/store/components/item-actions/action-button';
import { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type ItemActionsProps = {
  publish?: ActionButtonBaseProps;
  saveDraft?: ActionButtonBaseProps;
  next?: ActionButtonBaseProps;
};
export type ActionButtonBaseProps = {
  onClick?: () => void;
  isFetching?: boolean;
  disabled?: boolean;
};
const ItemActions: FC<ItemActionsProps> = t0 => {
  const $ = _c(21);
  const {
    saveDraft,
    publish,
    next
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = saveDraft?.disabled || publish?.isFetching;
  let t2;
  if ($[0] !== t) {
    t2 = t("dashboard.store.item.save_draft");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== saveDraft || $[3] !== t1 || $[4] !== t2) {
    t3 = <ActionButton ButtonComponent={SecondaryButton} {...saveDraft} disabled={t1}>{t2}</ActionButton>;
    $[2] = saveDraft;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = publish?.disabled || saveDraft?.isFetching;
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.store.item.publish");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== publish || $[9] !== t4 || $[10] !== t5) {
    t6 = <ActionButton ButtonComponent={PrimaryButton} {...publish} disabled={t4}>{t5}</ActionButton>;
    $[8] = publish;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("global.next");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== next || $[15] !== t7) {
    t8 = <ActionButton ButtonComponent={PrimaryButton} {...next}>{t7}</ActionButton>;
    $[14] = next;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div className="flex flex-col justify-between gap-5 sm:flex-row"><div className="flex w-full justify-end"><div className="flex w-full flex-col gap-5 sm:w-fit sm:flex-row">{t3}{t6}{t8}</div></div></div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default ItemActions;